
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogApiPathGrid extends Serenity.EntityGrid<LogApiPathRow, any> {
        protected getColumnsKey() { return LogApiPathColumns.columnsKey; }
        protected getDialogType() { return LogApiPathDialog; }
        protected getIdProperty() { return LogApiPathRow.idProperty; }
        protected getInsertPermission() { return LogApiPathRow.insertPermission; }
        protected getLocalTextPrefix() { return LogApiPathRow.localTextPrefix; }
        protected getService() { return LogApiPathService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            // button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogApiPathService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}